module.exports = __webpack_public_path__ + "img/img_title2.0996e34c.png";